(function () {
  'use strict';

  function init() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    var bar = document.getElementById('marbenio-sticky-atc');
    if (!bar) return;

    var submitId = bar.getAttribute('data-submit-id');
    var mainBtn = submitId ? document.getElementById(submitId) : null;
    if (!mainBtn) {
      var tries = 0;
      var retry = setInterval(function () {
        tries += 1;
        mainBtn = submitId ? document.getElementById(submitId) : null;
        if (mainBtn || tries > 24) {
          clearInterval(retry);
          if (mainBtn) boot(bar, mainBtn);
        }
      }, 150);
      return;
    }

    boot(bar, mainBtn);
  }

  function boot(bar, mainBtn) {
    var stickyBtn = bar.querySelector('.marbenio-sticky-atc__btn');
    if (!stickyBtn) return;

    var stickyPrice = bar.querySelector('[data-sticky-price]');
    var shown = false;
    var showTimer = null;
    var hideTimer = null;

    function setVisible(next) {
      if (shown === next) return;
      shown = next;
      bar.classList.toggle('is-visible', next);
      bar.setAttribute('aria-hidden', next ? 'false' : 'true');
      document.documentElement.classList.toggle('ql-sticky-atc-open', next);
    }

    function syncStickyButton() {
      stickyBtn.disabled = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
      stickyBtn.classList.toggle('loading', mainBtn.classList.contains('loading'));
      stickyBtn.classList.toggle('is-added', mainBtn.classList.contains('is-added'));

      var stickySpinner = stickyBtn.querySelector('.loading__spinner');
      if (stickySpinner) {
        stickySpinner.classList.toggle('hidden', !mainBtn.classList.contains('loading'));
      }

      var stickyLabel = stickyBtn.querySelector('span:not(.loading__spinner)');
      var mainLabel = mainBtn.querySelector(
        'span:not(.ql-pdp-draft__submit-check):not(.loading__spinner)'
      );
      var labelText = mainLabel ? mainLabel.textContent : mainBtn.textContent;
      if (stickyLabel && labelText) {
        stickyLabel.textContent = labelText.trim();
      }

      if (stickyPrice) {
        var livePrice = document.querySelector('.ql-pdp-draft__price');
        if (livePrice && livePrice.textContent) {
          stickyPrice.textContent = livePrice.textContent.trim();
        }
      }
    }

    syncStickyButton();

    if (typeof subscribe !== 'undefined' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, syncStickyButton);
    }

    var btnObserver = new MutationObserver(syncStickyButton);
    btnObserver.observe(mainBtn, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
      subtree: true,
      childList: true,
      characterData: true
    });

    var priceNode = document.querySelector('.ql-pdp-draft__price');
    if (priceNode) {
      var priceObs = new MutationObserver(syncStickyButton);
      priceObs.observe(priceNode, { childList: true, characterData: true, subtree: true });
    }

    var visibilityObserver = new IntersectionObserver(
      function (entries) {
        var inView = entries[0].isIntersecting;
        clearTimeout(showTimer);
        clearTimeout(hideTimer);

        if (inView) {
          hideTimer = setTimeout(function () {
            setVisible(false);
          }, 80);
        } else {
          showTimer = setTimeout(function () {
            setVisible(true);
          }, 180);
        }
      },
      { threshold: 0, rootMargin: '0px 0px -12px 0px' }
    );

    visibilityObserver.observe(mainBtn);

    var rect = mainBtn.getBoundingClientRect();
    if (rect.bottom < 8 || rect.top > window.innerHeight) {
      setVisible(true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
